<template>
  <section id="island" data-section="The ocean" data-section-fr="L’Océan">
    <div class="wrapper">
      <div class="content">
        <div class="title ft-50">{{$t('home.Island.text1')}}</div>
<!--        <div class="sub ff-dr ft-30">Professional</div>-->
        <div class="sub ft-30">{{$t('home.Island.text2')}}</div>
        <div class="info ft-14">{{$t('home.Island.text3')}}</div>

        <Knowbtn1 @btnclick="gotoPage" />
      </div>
    </div>

    <div
      class="scene"
      data-bg
      data-tablet="/images/island-tablet.jpg"
      data-mobile="/images/island-mobile.jpg"
    ></div>
    <canvas class="displacement"></canvas>
  </section>
</template>

<script>
import Knowbtn1 from '@/components/Knowbtn1.vue'
import SceneIsland from '@/oceanSchool/sceneIsland.js'

export default {
  components: {
    Knowbtn1
  },

  beforeDestroy () {
    this.sceneIsland && this.sceneIsland.dispose()
    this.sceneIsland = null
  },

  methods: {
    start () {
      this.sceneIsland = new SceneIsland(this.$el)
    },
    gotoPage () {
      let routeUrl = this.$router.resolve('/base')
      window.open(routeUrl.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  color: #fff;
}

#island {
  padding: 160px 0 0 0;
  overflow: visible
}

body:not(.desktop) #island {
  min-height: 100vh
}

body:not(.desktop) #island .color--bluelight {
  color: #eee!important
}


.content {
  .title {
    margin-bottom: 30px;
    font-size: 35px;
    background-image: -webkit-gradient(linear, left 0, right 0, from(rgb(96, 123, 153)), to(rgb(255, 255, 255)));
    -webkit-background-clip: text; /*必需加前缀 -webkit- 才支持这个text值 */
    -webkit-text-fill-color: transparent; /*text-fill-color会覆盖color所定义的字体颜色： */
  }

  .sub {
    line-height: 60px;
    color: #94b2be;
  }

  .info {
    line-height: 36px;
    max-width: 488px;
    margin-bottom: 30px;
    color: #94b2be;
  }
}
@media (max-width:1366px){
  .content{
    margin-left: 5%;
  }
}
@media (max-width: 1024px) {
  #island {
      padding-top:100px;
      height: 110vh!important
  }
}

@media (max-width: 480px) {
  #island {
      padding-top:50px
  }
}

#island .scene:before {
  content: "";
  left: -50%;
  width: 200%;
  height: 100%;
  top: 0;
  background: #c2c7d0;
  background: radial-gradient(ellipse at center 65%,#c2c7d0 0,#6287af 30%,#05111f 70%);
}

@media (max-width: 1024px) {
  body:not(.desktop) #island .scene:before {
      display:none
  }
}

#island canvas {
  top: 520px;
  z-index: 1050;
}

@media (min-width: 1681px) {
  #island canvas {
      top:560px
  }
}

@media (max-width: 1280px) {
  #island canvas {
      top:480px
  }
}

@media (max-width: 1024px) {
  #island .text--medium {
      color:#fff!important
  }
}
</style>
